module.exports = __webpack_public_path__ + "img/spain.13e17c6c.png";